import { Component } from '@angular/core';
import { AuthService } from '@core/services/auth/auth.service';
import { NgIdleService } from '@core/services/user-idle-manager/ng-idle.service';

@Component({
  selector: 'Teranet-GoToLogin',
  templateUrl: './go-to-login.component.html',
  styleUrls: ['./go-to-login.component.scss']
})

export class GoToLoginComponent {
  constructor(public idle: NgIdleService, public authService: AuthService) {
    this.authService.logout();
  }
}
